import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import Layout from './components/Layout';
import Login from './pages/Login';
import ForceChangePassword from './pages/ForceChangePassword';
import Dashboard from './pages/Dashboard';
import SessionDetail from './pages/SessionDetail';
import { SessionsListRoute, NewSessionRoute } from './components/SessionsRouteGuards';
import Profile from './pages/Profile';
import Users from './pages/Users';
import Tickets from './pages/Tickets';
import TicketDetail from './pages/TicketDetail';
import MyTickets from './pages/MyTickets';
import InstallRecorder from './pages/InstallRecorder';
import LoadingSpinner from './components/LoadingSpinner';
import RecordingDebug from './components/RecordingDebug';
import ButtonShowcase from './components/ButtonShowcase';
import VideoProcessingSettings from './pages/VideoProcessingSettings';
import VideoDeliveryPublic from './pages/VideoDeliveryPublic';

function RedirectToLogin() {
  const location = useLocation();
  const returnUrl = `${location.pathname}${location.search}`;
  const to =
    returnUrl && returnUrl !== '/'
      ? `/login?returnUrl=${encodeURIComponent(returnUrl)}`
      : '/login';
  return <Navigate to={to} replace />;
}

function App() {
  const { user, loading } = useAuth();

  return (
    <Routes>
      {/* Public customer link — no login */}
      <Route path="/v/:code" element={<VideoDeliveryPublic />} />

      {loading ? (
        <Route
          path="*"
          element={
            <div className="min-h-screen flex items-center justify-center">
              <LoadingSpinner size="lg" />
            </div>
          }
        />
      ) : !user ? (
        <>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<RedirectToLogin />} />
        </>
      ) : user.mustChangePassword ? (
        <>
          <Route path="/force-change-password" element={<ForceChangePassword />} />
          <Route path="*" element={<Navigate to="/force-change-password" replace />} />
        </>
      ) : (
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="sessions" element={<SessionsListRoute />} />
          <Route path="sessions/new" element={<NewSessionRoute />} />
          <Route path="sessions/:id" element={<SessionDetail />} />
          <Route path="users" element={<Users />} />
          <Route path="video-processing-settings" element={<VideoProcessingSettings />} />
          <Route path="tickets" element={<Tickets />} />
          <Route path="tickets/:id" element={<TicketDetail />} />
          <Route path="my-tickets" element={<MyTickets />} />
          <Route path="install-recorder" element={<InstallRecorder />} />
          <Route path="profile" element={<Profile />} />
          <Route path="debug" element={<RecordingDebug />} />
          <Route path="buttons" element={<ButtonShowcase />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      )}
    </Routes>
  );
}

export default App;
